import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-circular-loader',
  styleUrl: 'signet-circular-loader.scss',
})
export class SignetCircularLoader {
  @Prop() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

  render() {
    const classes = {
      'signet-circular-loader': true,
      [`signet-circular-loader-${this.size}`]: true,
    };

    return <div class={classes}></div>;
  }
}
